import React, { memo, useCallback, useEffect, useState } from 'react';
import { Marker, Map, useMap } from '@vis.gl/react-google-maps';

import { useGetBreakPoints } from '@/constants/media';

import ZoomMinusIcon from '@/components/SvgComponents/ZoomMinusIcon';
import ZoomPlusIcon from '@/components/SvgComponents/ZoomPlusIcon';

import styles from './index.module.scss';

function GoogleMap({
  branches,
  mobileSearch,
  onMarkerClick = () => null,
  center,
}) {
  const map = useMap('branch');
  const { isTablet } = useGetBreakPoints();
  const [zoomLevel, setZoomLevel] = useState(12);

  const handleMarkerClick = useCallback((markerPosition, id, name) => {
    onMarkerClick(id, name);
    map?.setOptions({
      center: markerPosition,
    });
  }, []);

  const handleZoom = (level) => {
    map?.setOptions({ zoom: level });
    setZoomLevel(level);
  };
  useEffect(() => {
    if (!center.lat) return;
    map?.setOptions({
      center,
    });
  }, [map, center]);

  return (
    <div
      className={`${styles.googleMapContainer} ${
        mobileSearch && styles.googleMapContainer__hidden
      }`}
      itemScope
      itemType='https://schema.org/Map'
    >
      <Map
        id='branch'
        defaultCenter={{
          lat: 40.409264,
          lng: 49.867092,
        }}
        defaultZoom={12}
        disableDefaultUI
      >
        {branches?.map(({ lat, lng, id, name }) => (
          <Marker
            key={id}
            position={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
            icon={{ url: '/assets/modalMarker.png' }}
            onClick={() =>
              handleMarkerClick(
                {
                  lat: parseFloat(lat),
                  lng: parseFloat(lng),
                },
                id,
                name,
              )
            }
          />
        ))}
        {isTablet && (
          <div className={styles.zoomControls}>
            <div
              className={styles.zoomIcon}
              onClick={() => handleZoom(zoomLevel + 1)}
            >
              <ZoomPlusIcon />
            </div>
            <div
              className={styles.zoomIcon}
              onClick={() => handleZoom(zoomLevel - 1)}
            >
              <ZoomMinusIcon />
            </div>
          </div>
        )}
      </Map>
    </div>
  );
}

export default memo(GoogleMap);
